import { cn } from '@/lib/utils';

interface BrandmarkProps {
  className?: string;
  size?: number;
}

/**
 * Coffee-bean+H monogram drawn as inline SVG so it inherits currentColor.
 * Two leaf-shaped halves on either side of an offset H stroke — reads as a
 * stylized coffee bean from a distance and a brand H up close.
 */
export function Brandmark({ className, size = 36 }: BrandmarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-hidden
    >
      <ellipse cx="24" cy="24" rx="18" ry="22" stroke="currentColor" strokeWidth="2.4" fill="none" transform="rotate(20 24 24)" />
      <path
        d="M16 12 C 12 24, 12 24, 16 36"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M32 12 C 36 24, 36 24, 32 36"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M14 24 H 34"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
